import z from 'zod';

import {BasePriceSourceEnumSchema, SalesPriceCalculationEnumSchema} from '@dms/api/warehouse';
import i18n from '@dms/i18n';

const SupplierSchema = z.object({
  id: z.string().nullable(),
});

export const WarehouseDetailFormSchema = z.object({
  // general
  name: z.string(),
  warehouseNumber: z.string().max(50),
  authorizationProfileId: z.string(),
  companyBillingInfoId: z.string(),
  branchId: z.string(),
  supportedMake: z.string().nullish(),
  defaultManufacturerId: z.string().nullish(),
  spaceIds: z.array(z.string()).nullish(),
  // accounting
  warehousePricing: z
    .array(z.enum(['AVG', 'FIFO']), {message: i18n.t('errors.field_is_required')})
    .min(1)
    .max(1), // wrapped in an array to ensure type safety with chips component and the validation
  currency: z.string(),
  isFastTrack: z.boolean(),
  dummyWarehouse: z.boolean(),
  workItemGroupId: z.string().nullish(),
  // pricing
  commercialOrderMarginMinimum: z.number().nullish(),
  salesPriceCalculation: SalesPriceCalculationEnumSchema,
  salePriceMarginPercent: z.number().nullish(),
  salePriceMarkupPercent: z.number().nullish(),
  salePriceProfitWithoutVat: z.number().nullish(),
  basePriceSource: BasePriceSourceEnumSchema,
  unitSalesPriceWithVat: z.boolean(),
  blockPricingSettingOnArticle: z.boolean(),
  restrictSaleBelowCost: z.boolean(),
  // documents
  receiveNoteSeriesId: z.string(),
  receiveNoteTemplateId: z.string().nullish(),
  creditNoteSeriesId: z.string(),
  creditNoteTemplateId: z.string().nullish(),
  issueNoteSeriesId: z.string(),
  issueNoteTemplateId: z.string().nullish(),
  issueNoteCorrectionSeriesId: z.string(),
  issueNoteCorrectionTemplateId: z.string().nullish(),
  allowServiceOrderIssue: z.boolean(),
  allowedOrderVariants: z.array(z.string()).nullish(),
  allowDirectSaleIssue: z.boolean(),
  allowedDirectSaleVariants: z.array(z.string()).nullish(),
  // suppliers
  allSuppliers: z.boolean(),
  suppliers: z.array(SupplierSchema),
  defaultSupplierId: z.string(),
});

export type WarehouseDetailForm = z.infer<typeof WarehouseDetailFormSchema>;
